module.exports = __webpack_public_path__ + "static/media/16.b1b687dd.jpg";